import React from "react";
import { Route, Switch } from "react-router-dom";
import AnnouncementsContainer from "./AnnouncementsContainer";
import ApplicantPoolContainer from "./applicantPool/ApplicantPoolContainer";
import CalendarHome from "./calendar";
import ManagerCalendar from "./calendar/ManagerCalendar";
import PersonelCalendar from "./calendar/PersonelCalendar";
import Competency from "./competency/Competency";
import CompletedTrainingsContainer from "./CompletedTrainingsContainer";
import Dashboard from "./Dashboard";
import DealerInfo from "./dealerInfo/DealerInfo";
import ModalDialog from "./elements/modal/ModalDialog";
import Employee360Container from "./employee360/Employee360Container";
import EmployeeRolesContainer from "./employeeRoles/EmployeeRolesContainer";
import EvolutionPlan from "./evolutionPlan/EvolutionPlan";
import Faq from "./Faq";
import Footer from "./Footer";
import FordOrganization from "./fordOrganization/FordOrganization";
import Guide from "./guide/Guide";
import Header from "./header/Header";
import InformationalVideosContainer from "./informationalVideos/InformationalVideosContainer";
import IntroductionVideosContainer from "./IntroductionVideosContainer";
import Invoices from "./invoices/Invoices";
import Invoiceapplicantreport from "./invoices/Invoiceapplicant";
import Invoiceemployeereport from "./invoices/Invoiceemployee";
import ManagerHome from "./ManagerHome";
import MyTeam from "./myteam/MyTeam";
import OrganisationActivities from "./organisationActivities/OrganisationActivities";
import OrganisationChart from "./OrganisationChart";
import PersonelHome from "./PersonelHome";
import PotentialTrainingsContainer from "./PotentialTrainingsContainer";
import Profile from "./Profile";
import RegisteredEmployeesContainer from "./RegisteredEmployeesContainer";
import SurveyContainer from "./survey/SurveyContainer";
import TrainingCatalogContainer from "./trainingCatalog/TrainingCatalogContainer";
import TrainingRequestsContainer from "./trainingRequests/TrainingRequestsContainer";
import EmployeeTrainingManagement from './employeeTrainingManagement/EmployeeTrainingManagement';
import Vision from "./Vision";
import AccessDenied from "./errorPages/AccessDenied";
import Asistant from "./fgaasistan/FgaAsistant";
import GuideCenter from "./guidecenter/GuideCenter";
import Scormlink from "./scormlink/scormlink";

const AppLayout = () => {
  return (
    <>
      <Header />

      <Switch>
        <Route path="/" exact component={Dashboard} />
        <Route path="/dashboard" exact component={Dashboard} />
        <Route path="/dashboard/personnel" exact component={PersonelHome} />
        <Route path="/dashboard/manager" exact component={ManagerHome} />
        <Route path="/profile" exact component={Profile} />
        <Route path="/faq" exact component={Faq} />
        <Route path="/ford-organization" exact component={FordOrganization} />
        <Route path="/vision" exact component={Vision} />
        <Route path="/guide" exact component={Guide} />
        <Route path="/my-team" exact component={MyTeam} />
        <Route path="/organisation" exact component={OrganisationChart} />
        <Route path="/evolution-plan/:userid?" component={EvolutionPlan} />
        <Route path="/survey" exact component={SurveyContainer} />
        <Route path="/competency/:serviceType?" exact component={Competency} />
        <Route
          path="/completed-trainings"
          exact
          component={CompletedTrainingsContainer}
        />
        <Route
          path="/training-requests"
          exact
          component={TrainingRequestsContainer}
        />
        <Route path="/invoices" exact component={Invoices} />
        <Route path="/Invoiceapplicant" exact component={Invoiceapplicantreport} />
        <Route path="/Invoiceemployee" exact component={Invoiceemployeereport} />
        <Route path="/my-guide-center" exact component={GuideCenter} />
        <Route
          path="/org-activities"
          exact
          component={OrganisationActivities}
        />
        <Route path="/calendar" exact component={CalendarHome} />
        <Route path="/calendar/manager" exact component={ManagerCalendar} />
        <Route path="/calendar/personnel" exact component={PersonelCalendar} />
        <Route path="/dealer-info" exact component={DealerInfo} />
        <Route path="/announcements" exact component={AnnouncementsContainer} />
        <Route path="/employee-training-management" exact component={EmployeeTrainingManagement} />
        <Route
          path="/introduction-videos"
          exact
          component={IntroductionVideosContainer}
        />
        <Route
          path="/potential-trainings"
          exact
          component={PotentialTrainingsContainer}
        />
        <Route
          path="/employee-training-registrations"
          exact
          component={RegisteredEmployeesContainer}
        />
        <Route
          path="/employee-roles"
          exact
          component={EmployeeRolesContainer}
        />
        <Route
          path="/informational-videos"
          exact
          component={InformationalVideosContainer}
        />
        {/* <Route
          path="/training-catalog"
          exact
          component={TrainingCatalogContainer}
        /> */}
        <Route
          path="/applicant-pool"
          exact
          component={ApplicantPoolContainer}
        />
        <Route path="/employee-360" exact component={Employee360Container} />
        <Route path="/access-denied" exact component={AccessDenied} />
        <Route path="/scormlink" exact component={Scormlink} />
        <Route path="*">
          <Dashboard />
        </Route>
      </Switch>
      <Footer />
      <ModalDialog />
      <Asistant />

    </>
  );
};

export default AppLayout;
